<template>
  <el-dialog
    :title="$t('user_profile.social.modals.title')"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    :close-on-press-escape=true
    custom-class="elsa-modal"
    :center=false
    width="255"
    top="100px"
    v-on:closed="closed"
  >
    <api-errors :errors="errors" />
    <el-form ref="definePasswordForm" :model="form" :rules="rules" @change.native="onChangePasswordChange">
      <elsa-input
        type="password"
        name="newPassword"
        :label="$t('user_profile.social.modals.password.label')"
        :placeholder="$t('user_profile.social.modals.password.placeholder')"
        v-model="form.newPassword"
      >
      </elsa-input>

      <elsa-input
        type="password"
        name="confirmNewPassword"
        :label="$t('user_profile.social.modals.repeat_password.label')"
        :placeholder="$t('user_profile.social.modals.repeat_password.placeholder')"
        v-model="form.confirmNewPassword"
      >
      </elsa-input>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <primary-button
        ref="handleDefinePasswordButton"
        @click.native="handleDefinePasswordClick"
        disabled
      >
        {{$t('user_profile.social.modals.save')}}
      </primary-button>
      <tertiary-button @click.native="handleCancelClick">{{$t('user_profile.social.modals.cancel')}}</tertiary-button>
    </span>
  </el-dialog>
</template>

<script>
  import PrimaryButton from '@/components/common/buttons/PrimaryButton'
  import TertiaryButton from '@/components/common/buttons/TertiaryButton'
  import ElsaInput from '@/components/common/Input'
  import ApiErrors from '@/components/common/ApiErrors'
  import { handleSubmitButtonState, isPropEmpty, handleFormValidation } from '../../../helpers/formValidationHelper'

  export default {
    name: "DefinePassword",
     props: ["dialogVisible"],
    components: {
      PrimaryButton,
      TertiaryButton,
      ElsaInput,
      ApiErrors,
    },
    data() {
      return {
        errors: [],
        form: {},
        rules: {
          newPassword: [
            { required: true, message: this.$t('user_profile.social.modals.password.validation_msg'), trigger: ['blur'] }
          ],
          confirmNewPassword: [
            { required: true, trigger: ['blur'], validator: this.validatePass }
          ]
        },
      }
    },
    methods: {
       validatePass (rule, value, callback) {
        if (this.form.newPassword !== value) {
          return callback(new Error(this.$t('user_profile.social.modals.password.not_match')))
        }

        return callback()
      },
      onChangePasswordChange() {
        const button = this.$refs.handleDefinePasswordButton.$el;
        const isInvalid = isPropEmpty('newPassword')(this.form) || isPropEmpty('confirmNewPassword')(this.form)
        return handleSubmitButtonState(button, isInvalid)
      },
      handleDefinePasswordClick () {
        const form = this.$refs.definePasswordForm.$el

        return handleFormValidation(form, this.submitDefinePassword, this.showError)
      },
      submitDefinePassword () {
        const { newPassword, confirmNewPassword } = this.form
        return this.$axios.put('/user/${this.userData.id}/password', {newPassword, confirmNewPassword})
          .then(this.handleClose)
      },
      showError () {},
      handleCancelClick () { this.$emit("closed") },
      handleClose () { this.$emit("closed") },
      closed () { this.form = {} },
    },
    watch: {
      dialogVisible (visible) {
        if(visible) {
          this.form = {}
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
